import { Box, Button, InputAdornment, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import TeamForm from '../../components/TeamMembers/TeamForm';
import Plus from "../../../src/assests/images/plusRed.svg";
import TeamTable from '../../components/TeamMembers/TeamTable';
// import { teamdata } from './api'
import { useMemo } from 'react';
import { decodeJWT, getToken } from "../../utils/utils";
import { Search } from "@mui/icons-material";
import { teamdata } from '../../pages/Teammembers/api';
interface Filters {
    [key: string]: {
        [key: string]: {
            checked: boolean;
            id: number;
        };
    };
}

interface Team {
    id: number;
    name: string;
    // add more fields based on your real API response
}
interface RowData {
    id: number;
    memberName: string;
    teams: string;
    moduleOwner: string;
    createdDate: string;
    moduleAccessAssigned: string;
    profile_request?: string;
    req_desc?: string;
    status: boolean;
    mainroles: number;
}

interface TeammembersProps {
  checked?: boolean; // Optional to match ProtectedRoute
  setChecked?: React.Dispatch<React.SetStateAction<boolean>>;
}

const OwnerTable: React.FC<TeammembersProps> = ({ checked, setChecked }) => {

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const [applydetailes, setapply] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const [teamIdMap, setTeamIdMap] = useState<Record<string, number>>({});
    const [moduleIdMap, setModuleIdMap] = useState<Record<string, number>>({});
    const [totalcount, settotalcount] = useState(0);
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);
    const [selectedRows22, setSelectedRows22] = useState<RowData[]>([]);

    const navigate = useNavigate();

       const [searchmainroles, setmainroles] = useState("");


    const [searchQuery, setSearchQuery] = useState("");
    const [teamList, setTeamList] = useState<Team[]>([]); const [onon, setonon] = useState(false);
    // const [totalPages, settotalPages] = useState(0);

    const perpagedata = 10;

    const [filters, setFilters] = useState<Filters>({
        team: {},
        module: {},
        creationDate: {},
    });
    console.log(filters, "filterssssssssssss3333")
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchQuery);
        }, 300); // 300ms debounce delay

        return () => {
            clearTimeout(handler);
        };
    }, [searchQuery]);

    const [applieddata, setapplieddata] = useState<Filters>({
        team: {},
        module: {},
        creationDate: {},
    });

    const token = getToken();

    const applyFilters = () => {
        setapplieddata(filters);
        setPage(1); // Reset page
        setTeamList([]); // Clear old data
        setonon(true);
        setapply(true)
        setTimeout(() => {
            setapply(false); // Run after 1 second
        }, 1000);
        // setapply(false)
    };
    console.log(applieddata, "applieddatassssssss")
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const teamCheckedIds = Object.entries(applieddata.team)
        .filter(([key, value]) => key !== "all" && value.checked)
        .map(([_, value]) => value.id);
    const moduleCheckedIds = Object.entries(applieddata.module)
        .filter(([key, value]) => key !== "all" && value.checked)
        .map(([_, value]) => value.id);

        const decodedToken = decodeJWT(token);
            console.log(decodedToken, "decodedTokendecodedTokendecodedToken",token, "tokentokentokentoken")
            const userRole = decodedToken?.user_role_name || "guest";
            const roleNames: string[] = decodedToken?.roleNames || [];
            
    console.log(teamCheckedIds, "teamCheckedIdsteamCheckedIds")
    console.log(selectedDate, "selectedDateselectedDate")
    const formattedDate = selectedDate
        ? `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`
        : '';
    console.log(formattedDate);
    const stableRoleNames = useMemo(() => roleNames, [roleNames.join(",")]);

const derivedRole = useMemo(() => {
  if (checked && roleNames.includes("Admin") && roleNames.includes("Module Owner")) {
    return "Admin";
  } else if (!checked && roleNames.includes("Admin") && roleNames.includes("Module Owner")) {
    return "Module Owner";
  } else if (userRole === "Admin") {
    return "Admin";
  } else if (userRole === "Module Owner") {
    return "Module Owner";
  }
  return "";
}, [checked, roleNames, userRole]);

const fetchTeamData = async () => {
  try {
    const response = await teamdata(
      token,
      teamCheckedIds,
      moduleCheckedIds,
      debouncedSearch,
      page,
      limit,
      derivedRole,
       selectedTab === 2 && applydetailes ? formattedDate : '',
      ""
    );

    setTeamList(response?.data?.data || []);
    console.log(response?.data?.count, "response?.data?.count");
    settotalcount(response?.data?.count || 0);
  } catch (error) {
    console.error("Error fetching team data:", error);
  }
};

useEffect(() => {
  fetchTeamData();
}, [applieddata, page, limit, debouncedSearch, teamIdMap, moduleIdMap, checked, stableRoleNames, derivedRole]);

    useEffect(() => {
        if (selectedTab === 2 && applydetailes) {
            fetchTeamData();
        }
    }, [formattedDate, selectedTab, applydetailes]);



    console.log(selectedTab, "selectedTabwwwwwww",)



    console.log(filters, "filtersfiltersfiltersfiltersfiltersfiltersfiltersfilters")
    console.log(totalcount, "teamListteamListteamListteamListteamList")

    console.log(selectedTab, "ppppppppppppppppppp")
    const totalPages = Math.ceil(totalcount / perpagedata);



    return (
        <>
            <Box sx={{ backgroundColor: "#FFF", padding: "32px" }}>
                <Link style={{ textDecoration: "none", fontSize: "14px", fontWeight: "600", color: "rgba(142, 2, 15, 1)", }} to={''}>Module Owner</Link>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="h3" sx={{ fontSize: "24px", fontWeight: "600", color: "#000", marginTop: "16px", }}>Module Owner</Typography>
                    <Button onClick={() => navigate("/team-Members/team-form")} sx={{ borderRadius: "8px", padding: "12px 15px", color: "#C8172F", textDecoration: "none", textAlign: "center", fontSize: "14px", fontWeight: "500", textTransform: "none", border: "1px solid #C8172F" }}>
                        <img style={{ marginRight: "8px" }} src={Plus} alt="Plus" />{" "}
                        Module Owner
                    </Button>

                </Box>
                <Box sx={{ maxWidth: "520px", flexGrow: 1, marginTop: "20px" }}>
                    <TextField
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        sx={{
                            ".MuiOutlinedInput-root": {
                                border: "none",
                                background: "#FFF",
                                color: "rgba(167, 168, 169, 1)",
                                borderRadius: "12px",
                                height: "48px",
                                width: "521px",
                                fontSize: "16px",
                                fontWeight: "500",
                                margin: "10px 0 0px",
                                "& input::placeholder": {
                                    color: "rgba(167, 168, 169, 1)",
                                    opacity: 1,
                                },
                            },
                            fontSize: "14px",

                            width: "100%",

                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    border: "2px solid #F5F5F5",
                                },
                                "&:hover fieldset": {
                                    borderColor: "#000",
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#000",
                                },
                            },
                        }}
                        placeholder="Search by Team, Role, Name, Modules"
                        type="search"
                        variant="outlined"
                        size="small"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Search
                                        sx={{
                                            background: "#FFFFFF00",
                                            height: "30px",
                                            width: "20px",
                                        }}
                                    />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>
            </Box>
            <TeamTable setSelectedDate={setSelectedDate}
                selectedRows22={selectedRows22}
                setSelectedRows22={setSelectedRows22}

                applydetailes={applydetailes}
                setapply={setapply}

                selectedDate={selectedDate} data={teamList} page={page} setPage={setPage} limit={limit} totalPages={totalPages} applyFilters={applyFilters} filters={filters}
                setFilters={setFilters}
                selectedTab1={selectedTab} setSelectedTab1={setSelectedTab} totalcount={totalcount}
            />
            {/* <TeamForm /> */}
        </>
    )
}

export default OwnerTable;